import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './components/main/main.component';

const routes: Routes = [
  {
    path: ':tag',
    component: MainComponent,
    data: {
      dontLoad: 'vwo',
      page_name: 'stories',
      category: 'fundraising',
      lastOrderSkip: false
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoryRoutingModule { }
